import { Map } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import {
  GET_MINDFUL_BREAKS,
  SET_MINDFUL_BREAKS_ORDER,
  DELETE_MINDFUL_BREAK,
  CREATE_MINDFUL_BREAK,
  UPDATE_MINDFUL_BREAK,
  TOGGLE_REMINDER_MINDFUL_BREAK,
  DISABLE_REMINDER_TYPE_MINDFUL_BREAK,
} from './actions'

export const INITIAL_STATE = new Map()

export const mindfulBreakSchema = new schema.Entity('mindfulBreak', {}, { idAttribute: '_id' })

export const mindfulBreaks = createReducer(INITIAL_STATE, {
  [GET_MINDFUL_BREAKS.FULFILLED]: (state, { payload }) =>
    new Map(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [SET_MINDFUL_BREAKS_ORDER.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [DELETE_MINDFUL_BREAK.FULFILLED]: (state, { payload }) => state.delete(payload),

  [CREATE_MINDFUL_BREAK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [UPDATE_MINDFUL_BREAK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [DISABLE_REMINDER_TYPE_MINDFUL_BREAK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [TOGGLE_REMINDER_MINDFUL_BREAK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [mindfulBreakSchema]).entities.mindfulBreak),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/mindful-breaks/reducers.js